<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row" style="gap: 1%;">
    <div class="flex-direction-column gap-10" style="width: 28%">
      <div class="center-center bg-primary color-text-primary cursor-pointer" (click)="abrirModalCadastroPerfil()"
           (keydown.enter)="abrirModalCadastroPerfil()" tabindex="0" role="button" style="padding: 5px; border-radius: 5px">
        <mat-icon class="font-16" style="height: 16px">add</mat-icon>
        <span class="weight-600 font-16 letter-spacing-0">Perfil</span>
      </div>

      <div class="flex-direction-column gap-10 bg-white" style="padding: 25px; height: 80vh; border-radius: 5px;">
        @for (perfil of perfis; track perfil.id) {
          <div class="flex-direction-row justify-between gap-10 align-center">
            <div class="flex cursor-pointer width-100 peris-lista" (click)="selecionarPerfil(perfil)"
                (keydown.enter)="selecionarPerfil(perfil)" tabindex="0" role="button"
                [ngStyle]="perfil.id === perfilSelecionado?.id ? {'background-color': 'rgba(221, 188, 255, 0.5)'} : {}">
              <span class="weight-600 font-14">{{perfil.nome}}</span>
            </div>
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" backgroundColor="transparent" (buttonClick)="abrirModalCadastroPerfil(perfil)"></app-button-padrao>
          </div>
        }
      </div>
    </div>

    <div class="flex-direction-column gap-10" style="width: 28%">
      <div class="center-center bg-primary color-text-primary cursor-pointer" (click)="abrirModalAssociarPerfilRotina()"
           (keydown.enter)="abrirModalAssociarPerfilRotina()" tabindex="0" role="button" style="padding: 5px; border-radius: 5px">
        <mat-icon class="font-16" style="height: 16px">add</mat-icon>
        <span class="weight-600 font-16 letter-spacing-0">Rotinas</span>
      </div>

      <div class="flex-direction-column gap-10 bg-white overflow" style="padding: 25px; height: 80vh; border-radius: 5px">
        @for (rotina of rotinasPerfil; track rotina.id) {
          <div class="flex-direction-row justify-between gap-10 align-center">
            <div class="flex cursor-pointer width-100 peris-lista" (click)="selecionarRotina(rotina)"
                 (keydown.enter)="selecionarRotina(rotina)" tabindex="0" role="button"
                 [ngStyle]="rotina.id === rotinaSelecionada?.id ? {'background-color': 'rgba(221, 188, 255, 0.5)'} : {}">
              <span class="weight-600 font-14">{{rotina.nome}}</span>
            </div>
            <app-button-padrao iconSrc="icones/delete-forever" iconSrcExtensao=".svg" width="25px" height="25px" backgroundColor="transparent" (buttonClick)="deletePerfilRotina(rotina)"></app-button-padrao>
          </div>
        }
      </div>
    </div>

    <div class="flex-direction-column gap-10" style="width: 18.5%">
      <div class="center-center bg-primary color-text-primary" style="padding: 5px; border-radius: 5px">
        <span class="weight-600 font-16 letter-spacing-0">Restrições de Rotina</span>
      </div>

      <div class="flex-direction-column gap-10 bg-white" style="padding: 25px; height: 80vh; border-radius: 5px;">
        @for (restricao of restricoesPerfil; track restricao.id) {
          <div class="flex-direction-row justify-between align-center" style="height: 29px;">
            <span class="weight-600 font-14">{{restricao.restricao?.nome}}</span>
            <mat-checkbox [(ngModel)]="restricao.permite" (ngModelChange)="alterarPermicao(restricao)"></mat-checkbox>
          </div>
        }
      </div>
    </div>

    <div class="flex-direction-column gap-10" style="width: 18.5%">
      <div class="center-center bg-primary color-text-primary" style="padding: 5px; border-radius: 5px">
        <span class="weight-600 font-16 letter-spacing-0">Usuários</span>
      </div>

      <div class="flex-direction-column gap-10 bg-white" style="padding: 25px; height: 80vh; border-radius: 5px;">
        @for (usuario of usuarios; track usuario.id) {
          <span class="weight-600 font-14" style="height: 29px;">{{usuario.nome}}</span>
        }
      </div>
    </div>
  </div>
</div>
